module.exports = __webpack_public_path__ + "img/siemens.e0201fd0.svg";